var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinOn = function SvgPinOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.879 27.605 10.704-10.704a2.27 2.27 0 0 0 2.88-.269.7.7 0 0 0 0-.99L32.357 5.537a.7.7 0 0 0-.99 0 2.27 2.27 0 0 0-.269 2.88L20.395 19.121a4.29 4.29 0 0 0-5.885.172.7.7 0 0 0 0 .99l5.353 5.353L9.739 35.758l-4.407 6.909 6.909-4.407 10.123-10.123 5.353 5.353a.7.7 0 0 0 .99 0 4.29 4.29 0 0 0 .172-5.885"
  })))));
};
export default SvgPinOn;